// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "The widget gives your audience a clear view of the outage, complete with a dynamic map, an estimated time of restoration, and the number of affected customers.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Power Outage Embed",
  id: "power-outage-embed",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable", "Explainer"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/power-outages-embed/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "PowerOutageEmbedConfigTool" */ "app/components/tools/PowerOutageEmbedConfigTool/PowerOutageEmbedConfigTool"),
    loading: DynamicImportLoader,
    modules: ["PowerOutageEmbedConfigTool"]
  })
};

export default CONFIG;
